export default __webpack_public_path__ + "static/media/biblia.4e30d5a2.png";